export default {
    sequence: 0
};

//# sourceMappingURL=sequence.js.map